/** Browser event used by the persistent bottom nav to refresh an open Home tab. */
export const HOME_REFRESH_EVENT = 'plantme:home-refresh';

/** Ask the mounted Home screen to refresh its visible-tier wallet balances. */
export function requestHomeRefresh(): void {
  window.dispatchEvent(new Event(HOME_REFRESH_EVENT));
}
